<i18n>
{
  "en": {
    "name": "Name of this social media",
    "accountId": "Account name of social media to display",
    "url": "URL of social media to redirect",
    "isVisible": "Visible",
    "createSocialMediaTitle": "Creating social media",
    "editSocialMediaTitle": "Editing social media",
    "emptyFieldError": "Required field",
    "image": "Social media icon",
    "fileFormatError": "This format is not valid",
    "previousFile": "Previous File",
    "pointsOfSales": "Select restaurants"
  },
  "es": {
    "name": "Nombre de la red social",
    "accountId": "Nombre de la cuenta de la red social",
    "url": "URL de la red social a redirigir",
    "isVisible": "Visible",
    "createSocialMediaTitle": "Creando red social",
    "editSocialMediaTitle": "Editando red social",
    "emptyFieldError": "Campo obligatorio",
    "image": "Icono de la red social",
    "fileFormatError": "Este formato no es válido",
    "previousFile": "Imagen anterior",
    "pointsOfSales": "Seleccionar restaurantes"
  }
}
</i18n>
<template>
  <v-dialog v-model="visible" max-width="600px" scrollable persistent>
    <v-card v-if="visible" scrollable persistent class="px-7 py-4">
      <v-card-title class="pa-0 mb-2">
        {{ modalTitle }}
      </v-card-title>
      <v-sheet style="background-color: #ffffff">
        <v-form v-model="valid" ref="form">
          <v-text-field v-model="socialMedia.name" :rules="emptyRules" :label="$t('name')" class="required"/>
          <v-text-field v-model="socialMedia.accountId" :rules="emptyRules" :label="$t('accountId')" class="required"/>
          <v-text-field v-model="socialMedia.url" :rules="emptyRules" :label="$t('url')" class="required"/>
          <v-checkbox v-model="socialMedia.isVisible" :label="$t('isVisible')"/>
          <v-file-input v-model="image" :rules="imageRules" :show-size="showImageSize"
              accept="image/png, image/jpeg, image/bmp" prepend-inner-icon="mdi-camera"
              prepend-icon="" :label="$t('image')" class="mb-6"/>
          <v-select v-model="posSelected" :rules="listRules" :items="pointOfSaleList" :menu-props="{ maxHeight: '400' }"
          :label="$t('pointsOfSales')" item-value="guid" chips multiple item-text="name" class="required"/>
          <dynameat-modal-buttons class="mt-3" @cancel="onCancel" @confirm="onConfirm" :confirmDisabled="!valid"/>
        </v-form>
      </v-sheet>
    </v-card>
  </v-dialog>
</template>
<script>
import {
  imageFileType,
  maxSize,
  notEmptyList,
  notEmptyString,
} from '@core/helpers/formValidators';
import Component from 'vue-class-component';
import { Components, MapGetters } from '@core/helpers/decorators';
import { Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import DynameatModalButtons from '@dynameat/components/DynameatModalButtons';
import { SocialMedia } from '../models';

@Component
@Components({ DynameatModalButtons })
@MapGetters(['pointOfSaleList'])
export default class SocialMediaCreateEditModal extends Vue {
  @Prop({
    Object,
    validator(socialMedia) {
      return socialMedia instanceof SocialMedia;
    }
  }) socialMedia;

  @Prop({
    String,
    default: 'create',
    validator(type) {
      return type === 'create' || type === 'edit';
    }
  }) type;

  @Prop({ Boolean, default: false }) visible;

  valid = false;

  posSelected = []

  image = null;

  get modalTitle() {
    return this.$t(`${this.type}SocialMediaTitle`);
  }

  get emptyRules() {
    return [notEmptyString(this.$t('emptyFieldError'))];
  }

  get listRules() {
    return [notEmptyList(this.$t('emptyFieldError'))];
  }

  get imageRules() {
    return [maxSize(this.$t('fileSizeError'), 2000000), imageFileType(this.$t('fileFormatError'))];
  }

  get showImageSize() {
    return this.image instanceof File && this.image.size > 0;
  }

  clearOwnData() {
    this.posSelected = [];
    this.image = null;
  }

  onCancel() {
    this.clearOwnData();
    this.$emit('cancel');
  }

  onConfirm() {
    if (this.$refs.form.validate()) {
      this.socialMedia.icon = this.image;
      this.socialMedia.posGuidList = this.posSelected;
      this.$emit('confirm', this.socialMedia);
    }
  }

  @Watch('socialMedia', { immediate: true })
  onSocialMediaChanged(newSocialMedia) {
    if (newSocialMedia) {
      this.clearOwnData();
      this.posSelected = newSocialMedia.posGuidList;
      this.image = newSocialMedia.icon ? new File([], this.$t('previousFile')) : null;
    }
  }
}
</script>
